import { BALANCE } from '../balance';
import { buildRegistry, type ContentRegistry, type RawContent } from '../registry';
import { ACHIEVEMENTS } from './achievements';
import { STARTER_BOXES } from './boxes';
import { COSMETICS } from './cosmetics';
import { COZINESS_REWARDS } from './coziness';
import { DIALOGUES } from './dialogues';
import { DECOR } from './items/decor';
import { FIXTURES } from './items/fixtures';
import { FURNITURE } from './items/furniture';
import { PRODUCTS } from './items/products';
import { HOME_LAYOUT, MINIMART_LAYOUT, STUDIO_LAYOUT } from './layouts';
import { LETTERS, MAILBOX_CYCLE, POSTCARDS } from './mailbox';
import { MINI_GAMES } from './minigames';
import { NPCS } from './npcs';
import { ORDER_TEMPLATES } from './orders';
import { SETS } from './sets';
import { STUDIO_LEVEL_REWARDS, STUDIO_SHOOTS } from './studio';
import { CHAPTERS } from './story';
import { SUGGESTIONS } from './suggestions';
import { UNLOCKS } from './unlocks';
import { WALL_FLOORS } from './wallFloors';
import { NEIGHBORHOOD_STORIES } from './neighborhood';

/** All MVP content as authored. Parsed and cross-checked by buildRegistry at boot and in tests. */
export const RAW_CONTENT: RawContent = {
  neighborhoodStories: NEIGHBORHOOD_STORIES,
  items: [...PRODUCTS, ...FURNITURE, ...DECOR, ...FIXTURES],
  sets: SETS,
  wallFloors: WALL_FLOORS,
  boxes: STARTER_BOXES,
  rooms: [HOME_LAYOUT, MINIMART_LAYOUT, STUDIO_LAYOUT],
  miniGames: MINI_GAMES,
  cozinessRewards: COZINESS_REWARDS,
  unlocks: UNLOCKS,
  achievements: ACHIEVEMENTS,
  suggestions: SUGGESTIONS,
  npcs: NPCS,
  dialogues: DIALOGUES,
  orderTemplates: ORDER_TEMPLATES,
  mailbox: MAILBOX_CYCLE,
  postcards: POSTCARDS,
  letters: LETTERS,
  chapters: CHAPTERS,
  cosmetics: COSMETICS,
  studioShoots: STUDIO_SHOOTS,
  studioLevelRewards: STUDIO_LEVEL_REWARDS,
  balance: BALANCE,
};

let cached: ContentRegistry | undefined;

/** The game's content registry (built once). Domain code still receives it as a parameter. */
export function getContent(): ContentRegistry {
  cached ??= buildRegistry(RAW_CONTENT);
  return cached;
}
